import { render, staticRenderFns } from "./Page404.vue?vue&type=template&id=1dc39c63&scoped=true"
import script from "./Page404.vue?vue&type=script&lang=js"
export * from "./Page404.vue?vue&type=script&lang=js"
import style0 from "./Page404.vue?vue&type=style&index=0&id=1dc39c63&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc39c63",
  null
  
)

export default component.exports